<template>
	<default-layout>
		<template #default>
			<b-spinner type="grow" :label="$t('Loading...')" variant="primary" />
			<p v-t="'Loading...'" />
		</template>
	</default-layout>
</template>

<script type="text/javascript">
import DefaultLayout from './DefaultLayout';
export default {
	name: 'Spinner',
	components: {
		DefaultLayout
	}
};
</script>
<style scoped>
.text-primary {
	color: #0088d3 !important;
}
</style>
